module.exports = __webpack_public_path__ + "static/cat-and-human-illustration-9c0792a4868eb126f7145d7d2fa5a172.svg";